<template>
  <el-dialog v-if="isvisible" :class="classes" :visible.sync="isvisible" v-bind="$attrs" append-to-body :width="width"
    :height="height" @close="close" @opened="opened">
    <div slot="title" class="rt-dialog-title-wrapper">
      <slot name="title">
        <div class="rt-dialog-title">
          {{ title }}
        </div>
        <rt-button v-if="showClose" icon-name="rt-base-close" text icon-size="24" color-type="info" type="plain"
          @click="close" />
      </slot>
    </div>
    <div class="rt-dialog-content-wrapper">
      <slot />
    </div>
    <div v-if="showFooter" slot="footer" class="rt-dialog-footer-wrapper">
      <slot name="footer">
        <div class="rt-dialog-footer-buttons">
          <!-- <rt-button @click="cancel">
            {{ $tx('取消', 'xpc.dialog.cancel') }}
          </rt-button> -->
          <rt-button @click="resetData">
            重置
          </rt-button>
          <rt-button type="primary" @click="confirm">
            {{ $tx('确认', 'xpc.dialog.confirm') }}
          </rt-button>
        </div>
      </slot>
    </div>
  </el-dialog>
</template>
<script>
import rtButton from '../button/rtButton';
import elDialog from 'vue-xpc/src/element-ui/packages/dialog'
export default {
  name: 'RtDialog',
  components: {
    rtButton,
    elDialog
  },
  props: {
    title: String,
    value: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    /**
     * @public 自定义dialog宽度
     */
    width: {
      type: String,
      default: ''
    },
    /**
     * @public 自定义dialog高度
     */
    height: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isvisible: this.value
    };
  },
  computed: {
    classes() {
      return {
        'rt-dialog-wrapper': true,
        'rt-dialog-wrapper-chrome-below-75': this.$xpc.isChromeBelow75(),
        [`rt-dialog-${this.size}`]: !(this.width && this.height)
      };
    }
  },
  watch: {
    value(newVal) {
      this.isvisible = newVal;
    }
  },
  methods: {
    resetData() {
      this.$emit('dialog-reset')
      this.close();
    },
    close() {
      this.isvisible = false;
      this.$emit('input', this.isvisible);
    },
    opened() {
      this.$emit('opened');
    },
    confirm() {
      this.$emit('confirm');
      if (this.validate) return;
      this.close();
    },
    cancel() {
      this.$emit('cancel');
      this.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDialog.vue?67b0c59b